import { useQuery } from 'react-query';

import {
  FORUM_POSTS_KEY,
  ForumPostOptions,
  ForumPostsResult,
  Pagination,
  getForumPosts,
} from '../utils/backend-api/forumPosts';

// TODO: move this to its own module
export const setPagination = (data: Pagination) => {
  const { hasNextPage, nextPage, page, totalCount, totalPages } = data;
  return { hasNextPage, nextPage, page, totalCount, totalPages };
};

export default function useForumPosts({
  onSearchPage = false,
  order = null,
  page = 1,
  perPage = 50,
  topic,
}: ForumPostOptions) {
  const { data, isLoading: areForumPostsLoading } = useQuery<ForumPostsResult>(
    [FORUM_POSTS_KEY, page, order, topic],
    () => getForumPosts({ page, perPage, order, topic, onSearchPage }),
    { keepPreviousData: true }
  );

  const pagination = data ? setPagination(data) : {};

  return { data, forumPosts: data?.forum_posts, areForumPostsLoading, pagination };
}
